import { render, staticRenderFns } from "./GuardProfile.vue?vue&type=template&id=07a1493b&"
import script from "./GuardProfile.vue?vue&type=script&lang=js&"
export * from "./GuardProfile.vue?vue&type=script&lang=js&"
import style0 from "./GuardProfile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports